module["exports"] = [
  "ie",
  "com",
  "net",
  "info",
  "eu"
];
